module.exports = __webpack_public_path__ + "img/kejarcuan-logo.e4883b68.svg";